import React, { useMemo } from 'react';
import { useChannelStateContext } from 'stream-chat-react';
import find from 'lodash/find';
import get from 'lodash/get';
import keys from 'lodash/keys';

import { Responsiveness } from '../../../elements-responsiveness/responsiveness';
import { useStreamChatContext } from '../../utils/utils';

export const HostResponsiveness = () => {
  const { ssoId, responsiveness, displayResponsiveness } = useStreamChatContext();
  const { host_id = '', hours = 0, level = 0 } = responsiveness ?? {};

  const isHost = host_id === ssoId;
  const { members } = useChannelStateContext();

  const interlocutorName = useMemo(() => {
    const ssoIds = keys(members);
    const interlocutorSSOid = find(ssoIds, (id) => id !== ssoId);

    return get(members, [interlocutorSSOid, 'user', 'name'], '');
  }, [members]);

  return (
    <div className="responsiveness-container relative">
      {displayResponsiveness
        && <Responsiveness
          placement="top"
          labelClassName="host-responsiveness capitalize-first-letter"
          ownerName={!isHost ? interlocutorName : ''}
          noTooltip={!isHost}
          level={level}
          responseTime={hours}
        />
      }
    </div>
  );
};
